module.exports = __webpack_public_path__ + "static/media/Ninja.d16771e5.jpg";